import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconBezierCurves1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBezierCurves1"><Path d="M21 4.5C10 4.5 14 19.5 3 19.5" stroke="currentColor"/><Circle cx="4.5" cy="4.5" r="1.5" fill="currentColor"/><Circle cx="19.5" cy="19.5" r="1.5" fill="currentColor"/><Path d="M16 19.5H19.5" stroke="currentColor"/><Path d="M5 4.5H8" stroke="currentColor"/><Path d="M10 4.5H14" stroke="currentColor"/><Path d="M10 19.5H14" stroke="currentColor"/></CentralIconBase>;
});

export default IconBezierCurves1;
